{
  "dashboard": {
    "toReceive": "عمليات تسليم بانتظار الاستلام",
    "countsFailed": "تعذّر تحميل: {{names}}",
    "attentionTitle": "بحاجة إلى متابعة",
    "attentionAlert": "متأخر الآن",
    "managementTitle": "التحليلات",
    "progressTitle": "سير العمل",
    "period": {
      "window": "آخر 12 شهرًا",
      "now": "الآن",
      "budgetPeriod": "فترة الميزانية الحالية"
    },
    "scopeNodes_zero": "لا وحدات شراء",
    "scopeNodes_one": "وحدة شراء واحدة",
    "scopeNodes_two": "وحدتا شراء",
    "scopeNodes_few": "{{count}} وحدات شراء",
    "scopeNodes_many": "{{count}} وحدة شراء",
    "scopeNodes_other": "{{count}} وحدة شراء",
    "reportingNotIncluded": "التقارير غير مشمولة لمنشأتك",
    "reportingNotIncludedBody": "لا تشمل اتفاقية منشأتك مع فِدلن التقارير، لذلك لا تظهر أرقامها ورسومها البيانية. عملك أدناه.",
    "figuresFailed": "تعذّر تحميل أرقام منشأتك.",
    "overdueValue": "متأخر: {{value}}",
    "onBehalfValue": "نيابةً عن آخرين: {{value}}",
    "lateValue": "متأخر: {{value}}",
    "lateDeliveries": "عمليات التسليم المتأخرة",
    "queues": {
      "inProgress": "قيد المعالجة",
      "returned": "أُعيدت إليك",
      "drafts": "المسودات",
      "toReview": "طلبات للمراجعة",
      "toSource": "تحتاج إلى توريد",
      "openRfqs": "طلبات عروض أسعار مفتوحة",
      "toSend": "أوامر بانتظار الإرسال",
      "supplierQueries": "استفسارات الموردين",
      "supplierDeclined": "رفضها المورد",
      "renewals": "اتفاقيات حان تجديدها",
      "qualifications": "تأهيلات بانتظار القرار"
    },
    "decisionContext": "الميزانية والاستثناءات",
    "decisionsFailed": "تعذّر تحميل القرارات التي بانتظارك.",
    "withHolder": "لدى",
    "nextDeliveries": "عمليات التسليم القادمة",
    "nextDeliveriesHint": "الأقرب موعدًا أولًا",
    "noDeliveries": "لا توجد عمليات تسليم بانتظار الاستلام.",
    "deliveriesFailed": "تعذّر تحميل عمليات التسليم المنتظرة.",
    "openReceiving": "فتح قائمة الاستلام",
    "late": "متأخر",
    "requestsTrendTitle": "الطلبات المُنشأة حسب الشهر",
    "requestsTrendSummary": "الطلبات المُنشأة في كل شهر من آخر 12 شهرًا، الأقدم أولًا. الشهر الحالي حتى تاريخه.",
    "requestsSeries": "الطلبات المُنشأة",
    "noRequestsInWindow": "لم تُنشأ طلبات في آخر 12 شهرًا.",
    "valueTrendTitle": "الملتزم به والمستلم حسب الشهر",
    "valueTrendSummary": "القيمة الملتزم بها في الأوامر الصادرة والقيمة المستلمة في كل شهر من آخر 12 شهرًا، الأقدم أولًا، لكل عملة. الشهر الحالي حتى تاريخه.",
    "committedSeries": "الملتزم به",
    "receivedSeries": "المستلم",
    "noValueInWindow": "لم يُلتزم بأي قيمة ولم يُستلم شيء في آخر 12 شهرًا.",
    "currencyColumn": "العملة",
    "categoryColumn": "الفئة",
    "orderedColumn": "قيمة الأوامر",
    "spendSummary": "قيمة أوامر الشراء خلال آخر 12 شهرًا حسب التجميع المختار: الخمسة الأكبر والباقي معًا، لكل عملة.",
    "budgetSummary": "أقرب {{shown}} ميزانيات إلى حدها أو تجاوزته، من أصل {{total}} في الفترة الحالية.",
    "viewAllBudgets": "عرض كل الميزانيات",
    "budgetColumn": "الميزانية",
    "allocatedColumn": "المخصص",
    "utilisationColumn": "المستخدم",
    "healthColumn": "الوضع",
    "executionTitle": "تنفيذ أوامر الشراء",
    "executionSummary": "الأوامر المفتوحة والمتأخرة والمستلمة جزئيًا الآن، والتسليم في الموعد خلال آخر 12 شهرًا.",
    "byFulfilment": "الأوامر المفتوحة حسب التسليم",
    "byResponse": "الأوامر المفتوحة حسب رد المورد",
    "notMeasured": "لم يُقَس بعد",
    "openReport": "فتح التقرير",
    "figureColumn": "المؤشر",
    "valueColumn": "القيمة",
    "periodColumn": "الفترة",
    "groupColumn": "التصنيف",
    "otherStatuses": "أخرى",
    "otherHolders": "جهات أخرى",
    "workloadTitle": "عبء الاعتمادات",
    "workloadSummary": "القرارات المنتظرة في مستواها الحالي: ضمن مهلة الخدمة أو متأخرة أو بلا مهلة؛ ومدة انتظارها؛ ومن ينتظرها لديه.",
    "workloadUnavailable": "أرقام عبء الاعتمادات غير متاحة بعد.",
    "nothingWaiting": "لا يوجد قرار منتظر.",
    "bySla": "حسب مهلة الخدمة",
    "byAge": "حسب مدة الانتظار",
    "byHolder": "حسب الجهة",
    "sla": {
      "within_sla": "ضمن المهلة",
      "overdue": "متأخر",
      "no_sla": "بلا مهلة محددة"
    },
    "latestFailed": "تعذّر تحميل أحدث طلباتك.",
    "exceptionsTitle": "استثناءات الاستلام حسب النوع",
    "exceptionsSummary": "استثناءات الاستلام المسجلة خلال آخر 12 شهرًا، حسب النوع.",
    "spendBy": {
      "category": "قيمة أوامر الشراء حسب الفئة",
      "supplier": "قيمة أوامر الشراء حسب المورد",
      "branch": "قيمة أوامر الشراء حسب وحدة الشراء"
    },
    "otherGroups": "أخرى",
    "spendBasisNote": "تُحسب قيمة الأوامر من أوامر الشراء الصادرة خلال الفترة وغير الملغاة.",
    "summaryTitle": "نظرة سريعة",
    "operationalQueues": "قوائم العمل",
    "operationAnalysis": "تحليل العمليات",
    "noAttention": "لا توجد اعتمادات متأخرة أو أوامر متأخرة أو استثناءات استلام ضمن هذه المؤشرات.",
    "openMyWork": "افتح مهامي",
    "workSummary": "قراراتك وطلباتك وتسليماتك، مجمّعة حسب المهام المتاحة لك.",
    "lifecycleTitle": "دورة حياة أوامر الشراء",
    "lifecycleSummary": "جميع أوامر الشراء الموجودة حالياً ضمن نطاق تقاريرك، بما فيها المسودات والأوامر المغلقة. يظهر كل أمر في حالة واحدة من دورة حياته، بصرف النظر عن الفترة الزمنية لاتجاه القيمة.",
    "noOrders": "لا توجد أوامر شراء في هذه البيانات.",
    "totalOrders": "إجمالي أوامر الشراء",
    "reviewDecision": "راجع الطلب"
  },
  "nav": {
    "reference": "البيانات المرجعية"
  }
}
